export const SET_CURRENT_COMPANY =  "SET_CURRENT_COMPANY"
